import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.string.isRequired,
  selected: PropTypes.bool
};

const defaultProps = {
  selected: false
};

const DropdownItem = ({ id, children, ...props }) => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (ref && ref.current) {
      setWidth(ref.current.getBoundingClientRect().width);
    }
  }, [ref]);

  return (
    <div
      ref={ref}
      id={id}
      role="button"
      tabIndex={0}
      className="p-3 outline-none hover:bg-blue-light"
      data-width={width}
      {...props}
    >
      {children}
    </div>
  )
};

DropdownItem.propTypes = propTypes;
DropdownItem.defaultProps = defaultProps;

export default DropdownItem;
